module.exports = __webpack_public_path__ + "img/product_rounded.9193b49.svg";